import {
  DocumentTextIcon,
  Cog6ToothIcon,
  ExclamationTriangleIcon,
  BeakerIcon,
  BuildingOfficeIcon,
  TruckIcon,
  WrenchScrewdriverIcon,
  ShieldCheckIcon,
  PresentationChartBarIcon,
  BuildingStorefrontIcon,
  DocumentCheckIcon,
  BanknotesIcon,
  ArchiveBoxIcon,
  ExclamationCircleIcon,
  ClipboardDocumentCheckIcon,
  FolderIcon,
} from '@heroicons/react/24/outline';
import type { ProductConfig } from '../registry';

export default {
  slug: 'precept',
  icon: ExclamationTriangleIcon,
  accentColor: {
    bg: 'bg-cyan-500/10',
    border: 'border-cyan-500/30',
    text: 'text-cyan-400',
  },
  // v1.2 — daily-use first, setup/directory pages grouped behind SETUP.
  // CALENDAR removed (duplicates the Cockpit's ComplianceCalendarPanel;
  // /precept/compliance/calendar still routable for deep links).
  navigation: [
    { name: 'COCKPIT', href: '/precept/cockpit', icon: PresentationChartBarIcon },
    { name: 'COMPOSE LOAD', href: '/precept/composer', icon: ClipboardDocumentCheckIcon },
    { name: 'WASTE STREAMS', href: '/precept/waste-streams', icon: BeakerIcon },
    { name: 'MANIFESTS', href: '/precept/manifests', icon: DocumentTextIcon },
    { name: 'INJECTION WELLS', href: '/precept/injection-wells', icon: WrenchScrewdriverIcon },
    { name: 'COMPLIANCE', href: '/precept/compliance', icon: ShieldCheckIcon },
    {
      name: 'SETUP',
      href: '',
      icon: FolderIcon,
      children: [
        { name: 'OPERATORS',   href: '/precept/operators',           icon: BuildingOfficeIcon },
        { name: 'HAULERS',     href: '/precept/haulers',             icon: TruckIcon },
        { name: 'RECEIVERS',   href: '/precept/receiver-facilities', icon: BuildingStorefrontIcon },
        { name: 'PERMITS',     href: '/precept/permits',             icon: DocumentCheckIcon },
        { name: 'FINANCIAL',   href: '/precept/financial-assurance', icon: BanknotesIcon },
        { name: 'CLOSURE',     href: '/precept/closure-plans',       icon: ArchiveBoxIcon },
        { name: 'CORRECTIVE',  href: '/precept/corrective-actions',  icon: ExclamationCircleIcon },
      ],
    },
    { name: 'SETTINGS', href: '/precept/settings', icon: Cog6ToothIcon },
  ],
  landingPage: '/precept/cockpit',
} satisfies ProductConfig;
